import { cardCompletionSaga } from './cardCompletion/actionSaga';
import { all, fork } from 'redux-saga/effects';
import { cardFlagSaga } from './cardFlag/actionSaga';

export default function* overviewCardSaga() {
  yield all([fork(cardCompletionSaga), fork(cardFlagSaga)]);
}
